import { store } from '../../store'
import { http } from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'api/request-qr'
    let options = {
      emulateJSON: false,
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    let xmlDownload = payload.response.data.data
    payload.event.context.xmlDownload = xmlDownload
    payload.event.context.loadingItems = false
  },
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loadingItems = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/satXmlDownload.js